import { z, ZodType } from 'zod';
import { PlayerVoucherItem, playerVoucherItemSchema } from './player-voucher-item';
import { ShiftExtended, shiftExtendedSchema } from './shift-extended';

export type CashdeskTransactionPlayer = {
	id: number;
	name: string;
	balance: number;
	order?: number;
	isConnected?: boolean;
	voucherItem: PlayerVoucherItem | null;
};

export const cashdeskTransactionPlayerSchema: ZodType<
	CashdeskTransactionPlayer,
	z.ZodTypeDef,
	unknown
> = z.object({
	id: z.number(),
	name: z.string(),
	balance: z.number(),
	order: z.number().optional(),
	isConnected: z.boolean().optional(),
	voucherItem: playerVoucherItemSchema.nullable(),
});

export type CashdeskTransaction = {
	player: CashdeskTransactionPlayer;
	shift: ShiftExtended;
};

export const cashdeskTransactionSchema: ZodType<CashdeskTransaction, z.ZodTypeDef, unknown> =
	z.object({
		player: cashdeskTransactionPlayerSchema,
		shift: shiftExtendedSchema,
	});
